import { ExpandingTextArea } from 'foundations-components/transitional/components/ExpandingTextArea';
import { useIsUngatedForDisplayOptimizedFormControl } from '../v2/hooks/useIsUngatedForDisplayOptimizedFormControl';
import { createTokenizedComponent, withoutClassName } from './helpers';
import UIExpandingTextArea from 'UIComponents/input/UIExpandingTextArea';
import { jsx as _jsx } from "react/jsx-runtime";
const TokenizedUIExpandingTextArea = createTokenizedComponent(UIExpandingTextArea);
export default function ExpandingTextAreaAdapter(props) {
  const isUngatedForDisplayOptimizedFormControl = useIsUngatedForDisplayOptimizedFormControl();
  if (isUngatedForDisplayOptimizedFormControl) {
    const rest = withoutClassName(props);
    return /*#__PURE__*/_jsx(ExpandingTextArea, Object.assign({}, rest));
  }
  return /*#__PURE__*/_jsx(TokenizedUIExpandingTextArea, Object.assign({}, props));
}